<template>
	<div
			:title="title"
			:class="[
         {
             'errorField': classError,
             'autocompleteField': isAutocomplete,
             'searchInput': isSearch,
             'style2': isStyle2,
             'borderRound': isRound,
             'offStyle': isSwitch || isOffStyle
         },
         inputClass,
          getColorInput
        ]"
			class="field"
			:style="{ width, margin, height, padding, borderRadius }"
	>
		<div v-if="label" class="label" :class="{'required': isRequired}">{{ label }}</div>
		<div v-if="isDate">
			<v-menu
					v-model="menu"
					:close-on-content-click="false"
					:nudge-top="20"
					transition="scale-transition"
					min-width="290px"
					:attach="isAttach"
					:left="isLeft"
					:disabled="isReadonly"
			>
				<template v-slot:activator="{ on, attrs }">
					<div class="dateWrapper">
						<input
								class="input"
								:type="type"
								:placeholder="placeholder"
								:value="monthMod && monthMod !== '' ? monthMod : dateValue"
								v-bind="attrs"
								v-on="on"
								readonly
						>
						<svg-sprite width="20" height="20" icon-id="date"></svg-sprite>
					</div>
				</template>

				<v-date-picker
						class="datePicker"
						color="green"
						prev-icon="mdi-menu-left"
						next-icon="mdi-menu-right"
						:value="dateValue"
						:no-title="isNoTitle"
						:events="functionEvents"
						:allowed-dates="onAllowedDates"
						@change="onDateChange"
						@input="updateDatePicker"
						:type="datePickerType"
				/>
			</v-menu>
		</div>
		<div v-else-if="isDateMultiple">
			<v-date-picker
					class="datePicker"
					color="green"
					prev-icon="mdi-menu-left"
					next-icon="mdi-menu-right"
					multiple
					no-title
					scrollable
					@change="onDateMultiple"
			></v-date-picker>
		</div>
		<div v-else-if="isTime" class="dateTime">
			<date-picker
					:value="dateValue"
					:format="format"
					:displayFormat="displayFormat"
					:placeholder="placeholder"
					:inputAttributes="{readonly: true}"
					:isRight="isRight"
					:weekdays="['M','T','W','T','F','S', 'S']"
					hasInputElement
					:pickTime="pickTime"
					:use12HourClock="use12HourClock"
					startWeekOnSunday
					:editable="!isDisabled"
					:isOnlyMonthAndYear="isOnlyMonthAndYear"
					:isOnlyTime="isOnlyTime"
					@input="onTimeChange"
					@updateToday="onToday"
			>
			</date-picker>
			<svg-sprite v-if="!isOnlyMonthAndYear" width="20" height="20" :icon-id="isOnlyTime ? 'icon_history' : 'date'"></svg-sprite>
		</div>
		<div v-else-if="isTextField">{{ textValue }}</div>
	  <div v-else-if="isTextarea">
			<textarea
			  class="textarea"
			  :value="setInputValue"
			  :placeholder="placeholder"
			  :style="{ minHeight }"
			  @input="onInput"
			  autofocus
	      resize
			  :disabled="isDisabled"
	  ></textarea>
	  </div>
		<div v-else-if="isAutocomplete" class="autocomplete">
			<v-autocomplete
					ref="ac"
					height="20px"
					:placeholder="placeholder"
					:item-text="itemText"
					:item-value="itemValue"
					:value="autocompleteValue"
					:items="items"
					:clearable="isClearable"
					:disabled="isDisabled"
					:auto-select-first="false"
					:menu-props="{ contentClass: 'fieldDropDown' }"
					:attach="isAttach"
					:loading="isLoading"
					@change="onAutocompleteChange"
					@update:search-input="getSearchText"
					@click:clear="onClear"
					return-object
					hide-details
					dense
			>
				<template v-if="isBtnAutocomplete" v-slot:append-outer>
					<button
							type="button"
							:disabled="!searchText"
							@mousedown.prevent
							@click.stop="onEquipmentSelectItem"
					>
						<svg-sprite width="16" height="16" icon-id="addItem"></svg-sprite>
					</button>
				</template>
			</v-autocomplete>
		</div>
		<div v-else-if="isDateRange">
			<v-menu
					v-model="menu"
					:close-on-content-click="false"
					transition="scale-transition"
					offset-y
					min-width="auto"
					:attach="isAttach"
					:disabled="isReadonly"
			>
				<template v-slot:activator="{ on, attrs }">
					<div class="dateWrapper" v-bind="attrs" v-on="on">
						<input
								class="input"
								:type="type"
								:placeholder="placeholder"
								:value="getDateRangeValue"
								readonly
						>
						<svg-sprite width="20" height="20" icon-id="date"></svg-sprite>
					</div>
				</template>

				<v-date-picker
						v-model="rangeDates"
						class="picker-table dataPickerFilter"
						:class="{ same: rangeDates.length === 2 && rangeDates[0] === rangeDates[1] }"
						width="300"
						color="green"
						prev-icon="mdi-menu-left"
						next-icon="mdi-menu-right"
						range
						no-title
						:allowed-dates="onAllowedDates"
						:events="functionEvents"
						@change="onDateRangeChange"
				></v-date-picker>
			</v-menu>
		</div>
		<div v-else-if="isMultiple" class="autocomplete multi">
			<v-autocomplete
					ref="ac"
					height="20px"
					:placeholder="placeholder"
					:item-text="itemText"
					:item-value="itemValue"
					:value="multiValue"
					:items="items"
					:clearable="isClearable"
					:disabled="isDisabled"
					:auto-select-first="false"
					:attach="isAttach"
					multipleSearch
					:search-input.sync="multipleSearch"
					@change="onMultiSelect"
					:menu-props="{ contentClass: 'multiSelectItem fieldDropDown' }"
					:return-object="isReturnObject"
					multiple
					hide-details
					dense
			>
				<template v-slot:prepend-item>
					<div v-if="isBtnAll" class="multiTop">
						<button @mousedown.prevent @click="onMultiClick" class="multiTop-btn">
							<svg-sprite icon-id="check" width="20" height="20"></svg-sprite>
							<span>Select all</span>
						</button>
					</div>
				</template>
				<template v-if="!hideSelection" v-slot:selection="{ item, index }">
					<span class="multiText" v-if="index === 0">{{ getText(item) }}</span>
					<span v-if="index === 1" class="extra"> +{{ multiValue.length - 1 }} </span>
				</template>
				<template v-slot:item="{ active, item, attrs, on }">
					<v-list-item v-on="on" v-bind="attrs" #default="{ active }">
						<v-list-item-action>
							<v-checkbox :ripple="false" dense :input-value="active"></v-checkbox>
						</v-list-item-action>
						<v-list-item-content>
							<v-list-item-title>
								<v-row no-gutters align="center">
									<span v-if="item.color" class="colorItem" :style="`background: ${item.color}`"></span>
									<span>{{ getText(item) }}</span>
								</v-row>
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</template>
			</v-autocomplete>
		</div>
		<div v-else-if="isSelect">
			<v-select
					:placeholder="placeholder"
					class="select multi"
					:items="items"
					:item-text="itemText"
					:item-value="itemValue"
					:value="autocompleteValue"
					:clearable="isClearable"
					:disabled="isDisabled"
					:attach="isAttach"
					@change="onSelect"
					append-icon="mdi-chevron-down"
					:menu-props="{ contentClass: 'fieldDropDown' }"
					:multiple="isMultiple"
					height="16"
					hide-details
					return-object
					dense
			>
				<template v-if="multiValue" v-slot:selection="{ item }">
					<span class="multiText">{{ item.value }}</span>
						<span
								v-if="multiValue.length"
								class="extra"
						>
	             +{{ +multiValue.length - 1 }}
	          </span>
				</template>
			</v-select>
		</div>
		<div v-else-if="isSelectIcon">
			<v-select
					:placeholder="placeholder"
					class="select multi"
					:items="items"
					:item-text="itemText"
					:item-value="itemValue"
					:value="autocompleteValue"
					:clearable="isClearable"
					:disabled="isDisabled"
					:attach="isAttach"
					@change="onSelect"
					append-icon="mdi-chevron-down"
					:menu-props="{ contentClass: 'fieldDropDown' }"
					:multiple="isMultiple"
					height="16"
					hide-details
					return-object
					dense
			>
				<template v-if="isSelectIcon" v-slot:selection="{ item }">
					<div class="selectIconWrap">
						<span class="icon">
							<svg-sprite width="22" height="22" :icon-id="item.id" style="color: #19BC38"></svg-sprite>
						</span>
						<span class="text">{{ item.name }}</span>
					</div>
				</template>
				<template v-if="isSelectIcon" slot="item" slot-scope="{ item }">
					<div class="selectIconWrap">
						<span class="icon">
							<svg-sprite width="22" height="22" :icon-id="item.id" style="color: #19BC38"></svg-sprite>
						</span>
						<span class="text">{{ item.name }}</span>
					</div>
				</template>
			</v-select>
		</div>

		<div v-else-if="isPhoneMask" class="inputWrap w1" :style="`gap: ${ iconGap }`">
			<input
					class="input"
					:class="[{'disabled': isDisabled}, `style_${inputTextStyle}`]"
					type="text"
					:value="setInputValue"
					autocomplete="tel"
					inputmode="tel"
					v-phone-mask-us="{
			      initial: setInputValue,
			      readonly: isReadonly,
			      onChange: (masked) => $emit('updateInput', { value: masked, idx })
			    }"
					ref="phoneInput"
					readonly="readonly"
			>
			<a v-if="isPhoneLink" class="btn-pass" :href="`tel:${ (setInputValue || '').replace(/\\D/g, '') }`">
				<svg-sprite width="20" height="20" icon-id="link"
				            :style="{ color: (setInputValue || '').replace(/\\D/g,'') ? '#19BC38' : '#8F90A6' }" />
			</a>
		</div>

		<div v-else-if="isFile" class="inputWrap w2">
			<input
					class="input"
					readonly="readonly"
					:value="setInputValue"
					placeholder="Add file"
					ref="input"
			>
			<button v-if="isFileIcon" class="mr15" type="button" @click="onView">
				<svg-sprite width="20" height="20" icon-id="eye" :style="`color: ${colorIcon}`"></svg-sprite>
			</button>
			<button type="button" :disabled="isDisabled" class="btnIcon" @click="onAddItem">
				<svg-sprite width="20" height="20" icon-id="addItem"></svg-sprite>
			</button>
			<div style="display: none">
				<input
						type="file"
						ref="fileCustomer"
						accept="image/png, image/jpeg,image/jpg, image/bmp, image/png, application/pdf, image/gif"
						@change="setNewItem($event)"
						class="d-none"
				/>
			</div>
		</div>
		<v-switch
				v-else-if="isSwitch"
				class="switchBlock"
				:class="{'dense': isDense}"
				:input-value="switchValue"
				@change="onSwitch"
				:label="labelSwitch"
				:color="colorSwitch"
				hide-details
		></v-switch>
		<v-checkbox
				v-else-if="isCheckbox"
				:style="{ width, margin, height, padding, borderRadius }"
				class="checkbox"
				:input-value="switchValue"
				:label="labelSwitch"
				:indeterminate="indeterminate"
				color="success"
				hide-details
				:disabled="isDisabled"
				@change="onSwitch"
		></v-checkbox>

		<div v-else-if="isTimeField" class="inputWrap w3" :style="`gap: ${ iconGap }`">
			<input
					class="input"
					:class="[{'disabled': isDisabled}, `style_${inputTextStyle}`]"
					:placeholder="placeholder"
					v-on:[getEvent]="onInputTime"
					:type="getType"
					@keyup.enter="onEnterTime"
					@blur="onBlurTime"
					@focus="onFocus"
					:readonly="isReadonly"
					v-model="localInputValue"
					@keydown="onKeydown"
					ref="input"
					@keydown.enter="onEnterTime"
					inputmode="tel"
					pattern="[0-9]*"
					autocomplete="off"
					autocorrect="off"
					autocapitalize="off"
					@touchstart="unlockReadonly"
					@mousedown="unlockReadonly"
			>
		</div>
		<div v-else class="inputWrap w4" :style="`gap: ${ iconGap }`">
			<input
					v-if="mask"
					class="input"
					:class="[{'disabled': isDisabled}, `style_${inputTextStyle}`]"
					type="text"
					:placeholder="placeholder"
					v-on:[getEvent]="onInput"
					v-mask="mask"
					v-model="localInputValue"
					@keyup.enter="onEnter"
					@blur="onBlur"
					@focus="onFocus"
					ref="input"
					readonly="readonly"
			>
			<input
					v-else
					class="input"
					:class="[{'disabled': isDisabled}, `style_${inputTextStyle}`]"
					:placeholder="placeholder"
					v-on:[getEvent]="onInput"
					@input="onInput"
					:type="getType"
					:value="setInputValue"
					@keyup.enter="onEnter"
					@blur="onBlur"
					@focus="onFocus"
					ref="input"
					readonly="readonly"
			>

			<button v-if="isLink" :disabled="!setInputValue" class="btn-pass" type="button" @click="doLink">
				<svg-sprite
						width="20" height="20" icon-id="link"
						:style="{ color: setInputValue ? '#19BC38' : '#8F90A6' }"
				></svg-sprite>
			</button>
			<a v-if="isPhoneLink" class="btn-pass" :href="`tel:${setInputValue?.replaceAll('-', '')}`">
			  <svg-sprite
				  width="20"
				  height="20"
				  icon-id="link"
		      :style="{ color: setInputValue ? '#19BC38' : '#8F90A6' }"
			  ></svg-sprite>
			</a>
			<button v-if="isPass" :disabled="!setInputValue" class="btn-pass" type="button" @click="doPass">
				<svg-sprite width="20" height="20" icon-id="eye" :style="{ color: '#19BC38' }"></svg-sprite>
			</button>
			<button v-if="isClip" type="button" @click="doCopy">
				<svg-sprite style="color: #19bc38" width="20" height="20" icon-id="copy"></svg-sprite>
			</button>

			<v-btn
					v-if="isAdd"
					:disabled="!isFilled"
					type="button"
					@click="onAdd"
					:icon="!addText"
					color="green"
					class="accountList_button"
			>
				<svg-sprite width="20" height="20" icon-id="addItem"></svg-sprite>
				<span v-if="addText" class="accountList_button-text">{{ addText }}</span>
			</v-btn>
			<tool-tip
					v-if="tooltip"
					:text="tooltip"
					:content-class="getPositionTooltip.contentClass"
					:position="getPositionTooltip.position"
			>
				<svg-sprite style="color: #19bc38" width="20" height="20" icon-id="attention"></svg-sprite>
			</tool-tip>
			<span v-if="icon" :class="['inputIcon', { mod: icon === 'edit' }]" @click="onIconField(icon)">
				<svg-sprite :style="`color: ${iconColor}`" width="20" height="20" :icon-id="'icon_' + icon"></svg-sprite>
      </span>
			<slot name="additionalElements"></slot>
		</div>
		<div v-if="classError || fileNameError" class="error--text mt-1 caption">
			{{ fileNameError || textError }}
		</div>

	</div>
</template>

<script>
import moment from "moment";
import getDefaultDate from "@/helper/getDefaultDate";
// components
import ToolTip from "@/shared/ToolTip/ToolTip";
// constants
import { fieldRegex } from "@/shared/Field/constants";

import Vue from 'vue';
// Prefered: as a plugin (directive + filter) + custom placeholders support
import VueMask from 'v-mask';
import fixTimeInput from "@/helper/fixTimeInput";
import { handleNewFile } from "@/helper/fileHelper";
import { normalizeToMasked } from '@/helper/phoneMaskUS';
Vue.use(VueMask);

export default {
	name: "Field",
	components: { ToolTip },
	props: {
		isTimeField: {
			type: Boolean,
			default: false
		},
		hideSelection: {
			type: Boolean,
			default: false
		},
		isDateRange: {
			type: Boolean,
			default: false
		},
		isRange: Boolean,
		isAdd: Boolean,
		isOnlyTime: Boolean,
		isRight: Boolean,
		isAutoGrow: Boolean,
		isTextField: Boolean,
		isOnlyMonthAndYear: Boolean,
		textValue: [ String, Number ],
		inputTextStyle: {
			type: String,
			default: () => '0'
		},
		isReturnObject: {
			type: Boolean,
			default: true
		},
		isDense: Boolean,
		colorIcon: String,
		inputClass: String,
		isSwitch: Boolean,
		isCheckbox: Boolean,
		indeterminate: {
			type: Boolean,
			default: false
		},
		isOffStyle: Boolean,
		isSearch: Boolean,
		isStyle2: Boolean,
		isRound: Boolean,
		isDateMultiple: Boolean,
		isMultiple: Boolean,
		isBtnAll: Boolean,
		isBtnAutocomplete: Boolean,
		eventsList: Object,
		colorSwitch: {
			type: String,
			default: () => 'success'
		},
		addText: {
			type: String,
			default: ''
		},
		use12HourClock: {
			type: Boolean,
			default: false
		},
		pickTime: {
			type: Boolean,
			default: () => true
		},
		isNoTitle: Boolean,
		format: {
			type: String,
			default: () => "YYYY-MM-DD HH:mm"
		},
		displayFormat: {
			type: String,
			default: () => "YYYY-MM-DD hh:mm"
		},
		datePickerType: {
			type: String,
			default: () => "date"
		},
		monthMod: {
			type: String,
			default: () => null
		},
		customClass: String,
		textError: String,
		title: String,
		isNumber: Boolean,
		isDisabled: Boolean,
		isLeft: Boolean,
		isAttach: Boolean,
		isLoading: Boolean,
		isFile: Boolean,
		isFileIcon: Boolean,
		isSelect: Boolean,
		isSelectIcon: Boolean,
		isTime: Boolean,
		tooltip: String,
		tooltipPosition: {
			type: String,
			default: 'top'
		},
		icon: {
			type: String,
			validator: function(value) {
				// Значение должно соответствовать одной из этих строк
				return [ 'percent', 'mi', 'ft', 'dollar', 'hh', 'search', 'true', 'false', 'undefined', 'edit' ].includes(value);
			}
		},
		closeMenuOnBtnClick: {
			type: Boolean,
			default: false,
		},
		iconColor: String,
		isClearable: {
			type: Boolean,
			default: () => true
		},
		itemText: {
			type: String,
			default: () => 'value'
		},
		itemValue: {
			type: String,
			default: () => 'id'
		},
		isReadonly: Boolean,
		dateValue: [ String, Array ],
		switchValue: Boolean,
		isColorInput: {
			type: Boolean,
			default: () => null
		},
		isLink: Boolean,
		isPhoneLink: Boolean,
		classError: Boolean,
		idx: Number,
		autocompleteValue: [ Object, Number, String ],
		multiValue: [ Array ],
		setInputValue: [ String, Number ],
		items: {
			type: Array,
			default: () => []
		},
		margin: {
			type: String,
			default: '0 10px'
		},
		padding: {
			type: String,
			default: '10px'
		},
		height: {
			type: String,
			default: 'inherit'
		},
		minHeight: {
			type: String,
			default: 'inherit'
		},
		borderRadius: {
			type: String,
			default: '4px'
		},
		isEnter: Boolean,
		isClip: Boolean,
		isTrim: Boolean,
		isPass: Boolean,
		isAutocomplete: Boolean,
		isTextarea: Boolean,
		isDate: Boolean,
		dateAllowed: Object,
		isPhone: Boolean,
		isPhoneMask: Boolean,
		label: String,
		mask: {
			type: String,
			default: ''
		},
		labelSwitch: String,
		isRequired: Boolean,
		placeholder: String,
		isInput: Boolean,
		type: String,
		width: {
			type: [ String, Number ],
			default: 220
		},
		iconGap: {
			type: [ String, Number ],
			default: 0
		}
	},
	computed: {
		getDateRangeValue() {
			if (!Array.isArray(this.rangeDates) || !this.rangeDates.length) return '';

			const from = this.rangeDates[0] || '';
			const to = this.rangeDates[1] || this.rangeDates[0] || '';

			if (!from) return '';

			return to ? `${ from } - ${ to }` : from;
		},
		getEvent() {
			if (this.isInput) return 'input';
			// return this.isPhone ? "keypress" : "change";
			return this.isPhone ? 'keypress' : 'input';

		},
		getPositionTooltip() {
			if (this.tooltipPosition === 'left') {
				return {
					contentClass: 'left',
					position: { left: true }
				};
			}

			return {
				contentClass: 'top',
				position: { top: true }
			};
		},
		getColorInput() {
			if (this.isColorInput === null) return '';
			return this.isColorInput ? 'greenInput' : 'redInput';
		},
		getType() {
			if (this.isType) return 'text';
			return this.type;
		},
		isFilled() {
			const v = this.localInputValue;
			// вважаємо 0 валідним значенням
			if (v === 0) return true;
			return v !== null && v !== undefined && String(v).trim() !== '';
		},
	},
	data: () => ({
		menu: false,
		isType: false,
		searchText: '',
		rangeDates: '',
		localInputValue: null,
		fileNameError: '',
		multipleSearch: '',
	}),
	mounted() {
		this.localInputValue = this.setInputValue;

		if (this.isPhoneMask) {
			this.$nextTick(() => {
				const el = this.$refs.phoneInput;
				if (!el) return;
				// Инициализируем БЕЗ emit

				const raw = typeof this.setInputValue === 'string' ? this.setInputValue : '';
				const { formatted, digits } = normalizeToMasked(raw);
				this.phoneDigits = digits;
				this.phoneMaskedLocal = formatted;

				// через тик разрешим эмиты
				setTimeout(() => {
					this.suppressEmit = false;
				}, 0);
				// подстраховка для автозаполнения — тоже без emit
				setTimeout(() => this.onAutofillNormalize(true), 120);
			});
		}
	},

	methods: {

		unlockReadonly() {
			const el = this.$refs.input;
			if (el && el.hasAttribute('readonly') && !this.isReadonly) {
				el.removeAttribute('readonly');
				el.focus();
			}
		},

		onIconField(icon) {
			if (icon === "edit") {
				const input = this.$refs.input;
				if (input) {
					if (input.hasAttribute('readonly') && !this.isReadonly) input.removeAttribute('readonly');
					input.focus();
					input.setSelectionRange(0, input.value.length);
				}
			}
		},

		onKeydown(evt) {
			if (!this.isTimeField) return;

			const { key, target } = evt;
			const cursorPos = target.selectionStart;

			if (key === 'Backspace' && cursorPos === 3) {
				// Удаляем двоеточие и предыдущую цифру
				let digits = this.localInputValue.replace(/[^0-9]/g, '').slice(0, 4);
				digits = digits.slice(0, 1); // удаляем 2-ю цифру часа

				this.localInputValue = digits;
				this.$refs.input.value = digits;
				this.$emit('updateInput', { value: digits, idx: this.idx });

				evt.preventDefault();
			}
		},
		onInputTime(evt) {
			if (!this.isTimeField) {
				const value = this.isTrim ? evt.target.value.trim() : evt.target.value;
				this.$emit('updateInput', { value, idx: this.idx });
				return;
			}

			// Разрешаем ввод только цифр и максимум 4 символа
			const raw = evt.target.value.replace(/[^0-9]/g, '').slice(0, 4);

			this.localInputValue = raw;
			this.$refs.input.value = raw;

			this.$emit('updateInput', { value: raw, idx: this.idx });
		},
		onBlurTime(evt) {
			if (!this.isTimeField) return;

			const formatted = fixTimeInput(evt.target.value);

			this.localInputValue = formatted;
			this.$emit('updateInput', { value: formatted, idx: this.idx });
		},
		onEnterTime() {
			if (this.isTimeField) {
				const formatted = fixTimeInput(this.localInputValue);
				this.localInputValue = formatted;
				this.$emit('updateInput', { value: formatted, idx: this.idx });
			}
		},
		onEnter(evt) {
			if (!this.isEnter) return false;
			const value = this.isPhone ? evt.target.value : +evt.target.value;
			const target = evt.target;
			this.$emit('updateInputWithEnter', { value, idx: this.idx, target });
		},
		getText(item) {
			if (!item.value) {
				return item[this.itemText];
			}

			return item.value;
		},
		onAllowedDates(value) {
			if (!this.dateAllowed) return true;
			if (this.dateAllowed.onlyMonday && this.dateAllowed.isSameOrBefore) {
				return new Date(moment(value).format()).getDay() === 1 && moment(value).isSameOrBefore(getDefaultDate());
			}
			if (this.dateAllowed.onlyMonday) return new Date(moment(value).format()).getDay() === 1;
			if (this.dateAllowed.isSameOrBefore) return moment(value).isSameOrBefore(getDefaultDate());
		},
		updateDatePicker() {
			this.menu = false;
			if (this.isRange) this.menu = true;
		},
		functionEvents(date) {
			if (!this.eventsList) return false;
			const { orange, white } = this.eventsList;
			const isWhite = white.includes(date);
			const isOrange = orange.includes(date);

			if (isWhite && isOrange) return [ 'white', 'orange' ];
			if (isOrange) return [ 'orange' ];
			if (isWhite) return [ 'white' ];
		},
		onSwitch(value) {
			this.$emit('updateSwitch', { value, idx: this.idx });
		},
		onFocus() {
			if (!this.isReadonly) this.$refs.input.removeAttribute('readonly');
		},
		onAutocompleteChange(value) {
			this.$emit('updateAutocomplete', { value, idx: this.idx });
		},
		onMultiSelect(value) {
			this.multipleSearch = '';
			this.$emit('updateMultiSelect', { value, idx: this.idx });
		},
		onDateMultiple(value) {
			this.$emit('updateDateMultiple', { value, idx: this.idx });
		},
		onMultiClick() {
			const value = this.items.filter(item => item.value);
			this.$emit('updateMultiSelect', { value, idx: this.idx });
		},
		getSearchText(value) {
			this.searchText = value;
			this.$emit('updateAutocompleteList', { text: value, idx: this.idx });
		},
		onClear() {
			this.$emit('updateClearAutocomplete', { value: null, idx: this.idx });
		},
		onEquipmentSelectItem() {
			if (this.closeMenuOnBtnClick) {
				const ac = this.$refs.ac;
				if (ac) {
					ac.isMenuActive = false;
					if (typeof ac.blur === 'function') ac.blur();
				}
			}

			this.$emit('updateSearchText', this.searchText);
		},
		onSelect(value) {
			this.$emit('updateSelect', { value, idx: this.idx });
		},
		onBlur(evt) {
			if (this.isPhone) this.$emit('updateInput', { value: evt.target.value, idx: this.idx });
		},
		onInput(evt) {
			const { target } = evt;
			if (this.isPhone) {
				const { keyCode } = evt;
				const key = String.fromCharCode(keyCode);
				const isNumbers = fieldRegex.test(key);

				if (!isNumbers) evt.preventDefault();
			}

			const value = this.isTrim ? target.value.trim() : target.value;

			this.localInputValue = value;

			this.$emit('updateInput', { value, idx: this.idx });
		},
		doCopy() {
			try {
				navigator.clipboard.writeText(this.setInputValue);
			} catch (e) {
				console.error(e);
			}
		},
		onAdd() {
			this.$emit('updateAdd');
		},
		doPass() {
			this.isType = !this.isType;
		},
		doLink() {
			window.open(`${ this.setInputValue }`, '_blank');
		},
		onDateChange(args) {
			const date = this.isRange ? this.rangeDates.join(' - ') : args;
			this.$emit('updateDate', date);
		},
		onTimeChange(date) {
			this.$emit('updateTime', date);
		},
		onToday() {
			this.$emit('updateToday');
		},
		setNewItem(evt) {
			const emit = (eventName, payload) => this.$emit(eventName, payload);
			const { error } = handleNewFile(evt, emit, { idx: this.idx });
			this.fileNameError = error; // показываем локальную ошибку под полем
		},
		onAddItem() {
			this.$refs.fileCustomer.click();
		},
		onView() {
			this.$emit('updateView');
		},
		onDateRangeChange(value) {
			this.rangeDates = Array.isArray(value) ? value.slice() : [];
			this.$emit('updateDate', this.rangeDates);

			if (this.rangeDates.length === 2) {
				this.menu = false;
			}
		},
	},
	watch: {
		dateValue: {
			immediate: true,
			deep: true,
			handler(newValue) {
				if (this.isDateRange) {
					this.rangeDates = Array.isArray(newValue) ? newValue.slice() : [];
				}
			}
		},
		setInputValue(newValue) {
			this.localInputValue = newValue;

			// Если значение извне обновили — синхронизируем маску
			if (this.isPhoneMask) {
				const { formatted, digits } = normalizeToMasked(String(newValue || ''));
				this.phoneDigits = digits;
				this.phoneMaskedLocal = formatted;
			}
		}
	}
};
</script>

<style scoped lang="scss">
@import "field";
.accountList_button {
	display: flex;
	align-items: center;
	gap: 6px;

	&-text {
		font-size: 14px;
		line-height: 1;
		text-transform: none;
	}
}
</style>

<style lang="scss">
@import "fieldGlobal";
</style>
